module.exports = __webpack_public_path__ + "img/arrow.24087688.svg";